import fetch from "auth/FetchInterceptor";

const returnsReportService = {};

const getStoreHeaders = () => {
  const storeId = localStorage.getItem("store_id") || "1";
  return { "Store-ID": storeId };
};

returnsReportService.getReturnsReport = function (params = {}) {
  const queryString = new URLSearchParams(params).toString();
  return fetch({
    url: `/reports/returns/${queryString ? `?${queryString}` : ""}`,
    method: "GET",
    headers: getStoreHeaders(),
  });
};

returnsReportService.getReturnsReportDetail = function (params = {}) {
  const queryString = new URLSearchParams(params).toString();
  return fetch({
    url: `/reports/returns/detail/${queryString ? `?${queryString}` : ""}`,
    method: "GET",
    headers: getStoreHeaders(),
  });
};

export default returnsReportService;
